module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "title-text"
  }, [_vm._v(_vm._s(_vm.$t("about.tab1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.company_intro_1")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.company_intro_2")))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t("about.company_intro_3")))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07ef5126","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About/aprofile.vue
// module id = 263
// module chunks = 1